<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <VueDatePicker v-model="date" :color="secCol">
          <template #activator="{ date }">
            <DropSelect
              :date="date"
              :type="'datePicker'"
              :supTitle="'Día a ejecutarse'"
              :placeholder="'Seleccione el día'"
              :icon="'schedule'"
            />
          </template>
        </VueDatePicker>
        <p class="danger-msg" v-if="!date && touch">Seleccione fecha</p>
      </div>
      <div class="col-md-6">
        <DropSelect
          :z-index="5"
          v-bind="selectDuration"
          v-model="selectDuration.selected"
        />
        <p class="danger-msg" v-if="!selectDuration.selected && touch">
          Seleccione duración
        </p>
      </div>
      <div class="col-md-6">
        <DropSelect
          :type="'timePicker'"
          :supTitle="'Horario de Inicio'"
          :placeholder="'Seleccione el horario'"
          :icon="'clock'"
          :z-index="4"
          :id="'time'"
          v-model="time"
        />
        <p class="danger-msg" v-if="!time && touch">
          Seleccione horario de inicio
        </p>
      </div>
      <div class="col-md-6">
        <DropSelect
          :z-index="3"
          v-bind="selectAmount"
          v-model="selectAmount.selected"
        />
        <p class="danger-msg" v-if="!selectAmount.selected && touch">
          Seleccione cantidad
        </p>
      </div>
      <div class="col-md-6 display-none">
        <DropSelect
          :z-index="2"
          v-bind="selectGrade"
          v-model="selectGrade.selected"
        />
        <p class="danger-msg" v-if="!selectGrade.selected && touch">
          Seleccione grado
        </p>
      </div>
      <div class="col-md-6">
        <DropSelect v-bind="selectCourse" v-model="selectCourse.selected" />
        <p class="danger-msg" v-if="!selectCourse.selected && touch">
          Seleccione curso
        </p>
      </div>
    </div>

    <div class="row my-4">
      <!-- <div class="col-lg-6 mx-auto text-center">
        <input
          type="text"
          v-model="sessionName"
          placeholder="Nombra la Sesión"
        />
        <p class="danger-msg" v-if="!sessionName && touch">
          Ingrese un nombre para la sesión
        </p>
      </div> -->
    </div>
    <div class="row ">
      <div class="col-lg-6 mx-auto text-center">
        <button class="button primary" @click="nextPage">
          Arma tus grupos
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DropSelect from "@/components/DropSelect";

export default {
  name: "WGModalFirstPage",
  components: {
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      sessionName: null,
      date: null,
      time: null,
      touch: false,
      secCol,
      selectTime: null,
      selectCourse: {
        id: "course",
        supTitle: "Curso o Sección",
        placeholder: "Elige el curso o sección",
        selected: "",
        icon: "graduation-hat",
        textKey: "name",
        valueKey: "id",
        options: [
          {
            text: "Curso 212",
            value: "212",
          },
        ],
      },
      selectDuration: {
        id: "duration",
        supTitle: "Duración",
        placeholder: "Selecciona la duración",
        selected: "",
        icon: "stopwatch",
        options: [
          {
            text: "30 minutos",
            value: "30",
          },
          {
            text: "45 minutos",
            value: "45",
          },
          {
            text: "60 minutos",
            value: "60",
          },
          {
            text: "90 minutos",
            value: "90",
          },
        ],
      },
      selectAmount: {
        id: "amount",
        supTitle: "Cantidad de desafíos",
        placeholder: "Selecciona la cantidad de desafíos",
        selected: "",
        icon: "dumbbell",
        options: [
          {
            text: "1",
            value: "1",
          },
          {
            text: "2",
            value: "2",
          },
          {
            text: "3",
            value: "3",
          },
          {
            text: "4",
            value: "4",
          },
          {
            text: "5",
            value: "5",
          },
        ],
      },
      selectGrade: {
        id: "grade",
        supTitle: "Nivel o Grado",
        placeholder: "Elije Nivel o Grado",
        selected: "",
        icon: "award",
        options: [
          {
            text: "Nivel 1",
            value: "1",
          },
          {
            text: "Nivel 2",
            value: "2",
          },
          {
            text: "Nivel 3",
            value: "3",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData", "courseList"]),
  },
  methods: {
    formatCourse(course) {
      let [number, section] = course.split("-");
      let type = parseInt(number) < 7 ? "primaria" : "secundaria";

      if (number > 6) number = number - 6;

      return `${number} ${type}-${section}`;
    },
    getCourses() {
      this.selectCourse.options = this.courseList;
    },
    async nextPage() {
      // from data
      let qtyOfTests = this.selectAmount.selected;
      let duration = this.selectDuration.selected;
      let course = {
        id: this.selectCourse.selected,
      };
      let { sessionName, time, date } = this;
      let { id } = this.teacherData;

      this.touch = true;
      let valid = true;

      // if (!sessionName) valid = false;
      if (!qtyOfTests) valid = false;
      if (!course.id) valid = false;
      if (!duration) valid = false;
      // if (!this.selectGrade.selected) valid = false;
      if (!time) valid = false;
      if (!date) valid = false;

      if (valid) {
        let payload = {
          id: "",
          teacher: {
            id,
          },
          qtyOfTests,
          dateTimeExecution: `${date} ${this.$timeConvertor(time)}`,
          duration,
          course,
        };

        // api url
        let apiUrl = `${this.dataUrl}/workSession/saveWorkSession`;

        let loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
        });

        try {
          let { data } = await this.axios.post(apiUrl, payload);

          let sessionData = {
            id: data.content.id,
            name: sessionName,
            course,
          };
          this.$emit("reloadSessions");
          if (data.status.code == 1) this.$emit("nextPage", sessionData);
        } catch {
          this.$notify({
            title: ["Ocurrió un error"],
            type: "danger",
          });
        } finally {
          loader.hide();
        }
      }
    },
  },
  mounted() {
    this.getCourses();
  },
};
</script>

<style lang="scss" scoped>
input {
  display: initial;
  width: inherit;
  max-width: auto;
  border: none;
  font-size: 25px;
  border: 0;
  border-bottom: 1px solid #cacaca;
  box-shadow: none;

  &:hover,
  &:focus {
    border: 0;
    border-bottom: 1px solid #cacaca;
    box-shadow: none;
  }
}

.display-none {
  display: none;
}
</style>
